import React from 'react';
export function CookiesPage() {
  return <div className="min-h-screen bg-[#faf8f6] py-12 md:py-20" data-id="element-539">
      <div className="max-w-4xl mx-auto px-6" data-id="element-540">
        <h1 className="text-4xl md:text-5xl font-serif text-[#2d2d2d] mb-8" data-id="element-541">
          Política de Cookies
        </h1>

        <div className="prose prose-lg max-w-none text-[#5a5a5a] space-y-6" data-id="element-542">
          <p className="text-sm text-[#8b6f6f]" data-id="element-543">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <section data-id="element-544">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-545">
              ¿Qué son las Cookies?
            </h2>
            <p data-id="element-546">
              Las cookies son pequeños archivos de texto que se almacenan en su
              dispositivo cuando visita un sitio web. Se utilizan ampliamente
              para hacer que los sitios web funcionen de manera más eficiente y
              proporcionar información a los propietarios del sitio.
            </p>
          </section>

          <section data-id="element-547">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-548">
              Tipos de Cookies que Utilizamos
            </h2>

            <h3 className="text-xl font-serif text-[#2d2d2d] mt-6 mb-3" data-id="element-549">
              1. Cookies Esenciales
            </h3>
            <p data-id="element-550">
              Estas cookies son necesarias para que el sitio web funcione
              correctamente. Incluyen cookies que le permiten acceder a áreas
              seguras del sitio y realizar compras.
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-2" data-id="element-551">
              <li data-id="element-552">Cookies de sesión</li>
              <li data-id="element-553">Cookies de seguridad</li>
              <li data-id="element-554">Cookies de carrito de compras</li>
            </ul>

            <h3 className="text-xl font-serif text-[#2d2d2d] mt-6 mb-3" data-id="element-555">
              2. Cookies de Rendimiento
            </h3>
            <p data-id="element-556">
              Estas cookies recopilan información sobre cómo los visitantes
              utilizan el sitio web, como qué páginas visitan con más
              frecuencia. Esta información se utiliza para mejorar el
              funcionamiento del sitio.
            </p>

            <h3 className="text-xl font-serif text-[#2d2d2d] mt-6 mb-3" data-id="element-557">
              3. Cookies de Funcionalidad
            </h3>
            <p data-id="element-558">
              Estas cookies permiten que el sitio web recuerde las elecciones
              que hace (como su idioma o región) y proporcionen características
              mejoradas y más personales.
            </p>

            <h3 className="text-xl font-serif text-[#2d2d2d] mt-6 mb-3" data-id="element-559">
              4. Cookies de Marketing
            </h3>
            <p data-id="element-560">
              Estas cookies se utilizan para rastrear a los visitantes en los
              sitios web. La intención es mostrar anuncios que sean relevantes y
              atractivos para el usuario individual.
            </p>
          </section>

          <section data-id="element-561">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-562">
              Cookies de Terceros
            </h2>
            <p data-id="element-563">
              Utilizamos servicios de terceros que pueden establecer cookies en
              su dispositivo:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-564">
              <li data-id="element-565">
                <strong data-id="element-566">Hotmart:</strong> Para procesar pagos de forma segura
              </li>
              <li data-id="element-567">
                <strong data-id="element-568">Google Analytics:</strong> Para analizar el tráfico del
                sitio web
              </li>
              <li data-id="element-569">
                <strong data-id="element-570">Redes sociales:</strong> Si compartimos contenido en
                plataformas sociales
              </li>
            </ul>
          </section>

          <section data-id="element-571">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-572">
              Cómo Controlar las Cookies
            </h2>
            <p data-id="element-573">
              Puede controlar y/o eliminar las cookies como desee. Puede
              eliminar todas las cookies que ya están en su dispositivo y puede
              configurar la mayoría de los navegadores para evitar que se
              coloquen.
            </p>
            <p className="mt-4" data-id="element-574">
              <strong data-id="element-575">Configuración del navegador:</strong>
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-576">
              <li data-id="element-577">
                <strong data-id="element-578">Chrome:</strong> Configuración → Privacidad y seguridad
                → Cookies
              </li>
              <li data-id="element-579">
                <strong data-id="element-580">Firefox:</strong> Opciones → Privacidad y seguridad →
                Cookies
              </li>
              <li data-id="element-581">
                <strong data-id="element-582">Safari:</strong> Preferencias → Privacidad → Cookies
              </li>
              <li data-id="element-583">
                <strong data-id="element-584">Edge:</strong> Configuración → Cookies y permisos del
                sitio
              </li>
            </ul>
            <p className="mt-4 text-sm italic" data-id="element-585">
              Nota: Si bloquea las cookies, algunas funciones del sitio web
              pueden no funcionar correctamente.
            </p>
          </section>

          <section data-id="element-586">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-587">
              Duración de las Cookies
            </h2>
            <p data-id="element-588">Las cookies que utilizamos tienen diferentes duraciones:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-589">
              <li data-id="element-590">
                <strong data-id="element-591">Cookies de sesión:</strong> Se eliminan cuando cierra su
                navegador
              </li>
              <li data-id="element-592">
                <strong data-id="element-593">Cookies persistentes:</strong> Permanecen en su
                dispositivo durante un período específico o hasta que las
                elimine manualmente
              </li>
            </ul>
          </section>

          <section data-id="element-594">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-595">
              Actualizaciones de esta Política
            </h2>
            <p data-id="element-596">
              Podemos actualizar esta Política de Cookies periódicamente para
              reflejar cambios en las cookies que utilizamos o por otras razones
              operativas, legales o reglamentarias.
            </p>
          </section>

          <section data-id="element-597">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-598">
              Más Información
            </h2>
            <p data-id="element-599">
              Si tiene preguntas sobre nuestra Política de Cookies, puede
              contactarnos a través de nuestro correo electrónico de soporte.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-[#d4a5a5]/30 flex gap-6" data-id="element-600">
          <a href="/" className="text-[#9d4b6b] hover:text-[#8b6f6f] transition-colors font-medium" data-id="element-601">
            ← Volver a la página principal
          </a>
          <button onClick={() => {
          // This would trigger a cookie consent modal in a real implementation
          alert('Configuración de cookies: Esta funcionalidad se implementaría con un banner de consentimiento de cookies.');
        }} className="text-[#9d4b6b] hover:text-[#8b6f6f] transition-colors font-medium" data-id="element-602">
            Configurar cookies
          </button>
        </div>
      </div>
    </div>;
}